export default "__VITE_ASSET__CvHIv7JS__"